import { sizeType } from "lib/interfaces"
import ImageComponent from "../Image"
import Text from "../Text"

export interface AvatarProps {
  variant:
    | "circular-image"
    | "circular-initial"
    | "square-outline"
    | "square-filled"
    | "special"
  size:
    | "extra-small"
    | "small"
    | "medium"
    | "large"
    | "extra-large"
    | "ultra-large"
    | "trainer-feedback"
  label?: string
  labelPosition?: "left" | "right" | "bottom" | "top"
  url?: string
  color?: "primary" | "secondary" | "danger" | "warning" | "success"
  rounded: "full" | "medium" | "none"
  resource?: "asset" | "cloud"
  loading?: boolean
  onClick?: () => void
}

function Avatar({
  variant,
  size,
  label,
  labelPosition,
  url,
  color,
  rounded,
  onClick,
}: AvatarProps) {
  let colorUi = ""
  let textColor = ""
  let containerUi = ""
  let sizeUi = ""
  let itemUi
  let roundedUi = ""
  let sizeText:sizeType

  switch (rounded) {
    case "full":
      roundedUi = "rounded-full"
      break
    case "medium":
      roundedUi = "rounded-md"
      break
    default:
      break
  }

  switch (color) {
    case "primary":
      colorUi = "bg-blue-400"
      textColor = "text-blue-600"
      break
    case "secondary":
      colorUi = "bg-gray-400"
      textColor = "text-gray-600"
      break
    case "danger":
      colorUi = "bg-red-400"
      textColor = "text-red-600"
      break
    case "warning":
      colorUi = "bg-yellow-400"
      textColor = "text-yellow-600"
      break
    case "success":
      colorUi = "bg-green-400"
      textColor = "text-green-600"
      break
    default:
      break
  }

  switch (size) {
    case "extra-small":
      sizeUi = "w-8	h-8 text-xs"
      break
    case "small":
      sizeUi = "w-10 h-10 text-sm"
      break
    case "medium":
      sizeUi = "w-12 h-12 text-md"
      break
    case "trainer-feedback":
      sizeUi = "w-16 h-16 text-md"
      break
    case "large":
      sizeUi = "w-24 h-24 text-lg"
      break
    case "extra-large":
      sizeUi = "w-36 h-36 text-xl"
      break
    case "ultra-large":
      sizeUi = "w-48 h-48 sm:w-px-400 sm:h-px-400 text-xl"
      break
    default:
      break
  }

  switch (variant) {
    case "circular-image":
      itemUi = (
        <div className="relative w-full h-full">
          <ImageComponent
            objectFit="cover"
            src={url}
            alt="circular"
            onClick={onClick}
          />
        </div>
      )

      break
    case "circular-initial":
      itemUi = <p>{label}</p>
      containerUi = `${colorUi} ${textColor}`
      break
    case "square-outline":
      itemUi = <p>{label}</p>
      containerUi = `border-2 border-${colorUi} ${textColor}`
      break
    case "square-filled":
      itemUi = <p>{label}</p>
      containerUi = `${colorUi} text-white`
      break
    case "special":
      itemUi = <p>{label}</p>
      containerUi = `${colorUi} text-white`
      break
    default:
      break
  }

  if (size === "trainer-feedback") {
    sizeText = "medium"
  } else {
    sizeText = size
  }

  const checkLabel = () => {
    let possition = ""
    let labelUi

    if (labelPosition === "top" || labelPosition === "bottom") {
      possition = "flex-col"
    }

    if (labelPosition === "left" || labelPosition === "top") {
      labelUi = (
        <div className={`flex w-max ${possition} items-center gap-x-2 gap-y-2`}>
          <Text color="gray" size={sizeText}>
            {label}
          </Text>
          <div
            className={`${sizeUi} ${roundedUi} overflow-hidden flex items-center justify-center ${containerUi}`}
          >
            {itemUi}
          </div>
        </div>
      )
    } else if (labelPosition === "right" || labelPosition === "bottom") {
      labelUi = (
        <div className={`flex w-max ${possition} items-center gap-x-2 gap-y-2`}>
          <div
            className={`${sizeUi} ${roundedUi} overflow-hidden flex items-center justify-center ${containerUi}`}
          >
            {itemUi}
          </div>
          <Text color="gray" size={sizeText}>
            {label}
          </Text>
        </div>
      )
    } else {
      labelUi = (
        <div
          className={`${sizeUi} ${roundedUi} overflow-hidden flex items-center justify-center ${containerUi}`}
        >
          {itemUi}{" "}
        </div>
      )
    }

    return labelUi
  }

  return <div>{checkLabel()}</div>
}

export default Avatar